import React from "react";
import Text from "../../../../../shared/components/Text";
import { SummaryConditionsRow } from "../../shared/components/SummaryConditionsRow";
import { formatMoney, formatPercent } from "@nemuru-eng/js-api-client";

export const LoanConditions = ({ loanConditions }) => {
  const {
    currency,
    period,
    principalAmount,
    tin,
    tae,
    totalAmountToPay,
    setupFee,
    gracePeriod,
  } = loanConditions;

  const formatAmount = (value) => {
    if (value === undefined) return "-";
    return formatMoney({ value, currency: currency ?? "EUR" }, 2);
  };

  return (
    <>
      <SummaryConditionsRow
        title={<Text tId="TERM" />}
        value={<Text tId={"X_MONTHS"} dynamicDataTexts={period} />}
      />
      <SummaryConditionsRow
        title={<Text tId="LOAN_TOTAL" />}
        value={formatAmount(principalAmount)}
      />
      <SummaryConditionsRow
        title={<Text tId="SETUP_FEE" />}
        value={formatAmount(setupFee)}
      />
      <SummaryConditionsRow
        title={<Text tId="TOTAL_TO_PAY" />}
        value={formatAmount(totalAmountToPay)}
      />

      <SummaryConditionsRow
        title={<Text tId="TIN" />}
        value={formatPercent(tin)}
      />
      <SummaryConditionsRow
        title={<Text tId="TAE" />}
        value={formatPercent(tae)}
      />
      {gracePeriod > 0 && (
        <SummaryConditionsRow
          title={<Text tId="GRACE_PERIOD" />}
          value={<Text tId={"X_MONTHS"} dynamicDataTexts={gracePeriod} />}
        />
      )}
    </>
  );
};
